import { render, staticRenderFns } from "./ObjectField.vue?vue&type=template&id=1256af4b&"
import script from "./ObjectField.vue?vue&type=script&lang=ts&"
export * from "./ObjectField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports